import logo from './logo.svg';
import './App.css';
import ChatContainer from './components/ChatContainer';

function App() {
  return (
    <ChatContainer />

  );
}

export default App;
